import { Events } from 'Models/ChatModel';
import { SOCKET_CHAT } from 'Root/plugins/socket/SocketAdapter';
import Notification from 'Root/classes/Notification';
import UserModel from 'Models/UserModel';
import FaviconModel from 'Models/FaviconModel';
import { changeFaviconAndTitle } from 'Root/helpers/tools';

const makeNotificationId = (orderId) => `${Events.NEW_MESSAGE}-${orderId}`;
let intervalId;

export const addNewMessageEventListeners = (ctx) => {
  const store = ctx.$store;
  const isCustomer = store.state.user.role === UserModel.ROLES.CUSTOMER.id;

  if (store.state.tabManager.channel._triggers?.[Events.NEW_MESSAGE]) {
    return;
  }

  const notificationAudioElement = new Audio('/sounds/notifications/new-chat-message.mp3');
  store.commit('notifications/mutateAudioElement', notificationAudioElement);
  store.dispatch('notifications/initAudioNotification');

  ctx.$socket.addListener(SOCKET_CHAT, Events.NEW_MESSAGE, (message) => {
    const notificationId = makeNotificationId(message.roomId);
    const hasThisNotification = store.state.notifications.notifications.find((n) => n.id === notificationId);

    if (hasThisNotification) {
      return;
    }

    const { split } = ctx.$route.query;
    const shouldNotify = split && isCustomer ? split !== message.roomId : message.roomId !== ctx.$route.params.id;

    const isMobile = store.state.userDevice.innerWidth < 1024;

    if (shouldNotify || (!shouldNotify && !document.hasFocus()) || (isMobile && !isCustomer && !shouldNotify)) { // hasFocus нужен для кейса, когда мы ушли на стороннюю вкладку
      const activeTabCallback = !isCustomer && !ctx.isNotificationMuted && !shouldNotify && document.hasFocus()
        ? null
        : () => store.dispatch('notifications/playNotificationAudio');

      store.state.tabManager.emit(Events.NEW_MESSAGE, { message }, activeTabCallback);
    }
  });

  store.state.tabManager.listenEvent(Events.NEW_MESSAGE, ({ message }) => {
    const shouldShowNotification = (isCustomer && ctx.$route.params.id !== (message.parentOrderId || message.roomId))
      || (!isCustomer && ctx.$route.params.id !== message.roomId && ctx.$route.name !== 'booster__multi-chat');

    if (!shouldShowNotification) { // Если это страница заказа
      if (isCustomer) { // Если клиент, то меняем флаг о непрочитанных для корректного отображения на сплитах
        const { split } = ctx.$route.query;
        const shouldChangeUnreadState = split ? split !== message.roomId : message.roomId !== ctx.$route.params.id;
        if (shouldChangeUnreadState) {
          const { order } = store.state.client;
          const currentOrder = order.id === message.roomId
            ? order
            : order._splits.find((o) => o.id === message.roomId);
          currentOrder.has_unread_messages = true;
        }
      } else {
        // Если про игрок, то мы открываем чат на мобилках
        // const pageRef = ctx.$refs.page;
        // if (!pageRef.isMobileChatOpen && pageRef.isMobile) {
        //   pageRef.setCurrentChat(message.roomId);
        // }
      }
      return;
    }

    const notificationId = makeNotificationId(message.roomId);

    if (!intervalId) { // Заводим лишь один интервал за раз
      let i = FaviconModel.DEFAULT.id;
      intervalId = setInterval(() => {
        i = i === FaviconModel.DEFAULT.id ? FaviconModel.NEW_MESSAGE.id : FaviconModel.DEFAULT.id;
        changeFaviconAndTitle(i, FaviconModel.ID_TO_DATA[i].title);
      }, 3000);
    }

    const notification = new Notification({
      type: Events.NEW_MESSAGE,
      id: notificationId,
      message_data: {
        orderId: message.roomId,
      },
      notificationClickHandler: () => {
        const linkParams = {
          name: isCustomer ? 'client__order-progress' : 'booster__multi-chat',
          params: {
            id: isCustomer ? message.parentOrderId || message.roomId : undefined,
          },
          query: {
            split: message.parentOrderId && isCustomer ? message.roomId : undefined,
            chat: isCustomer ? undefined : message.roomId,
          },
        };

        ctx.$router.push(linkParams);
      },
      notificationHideHandler: () => {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
          changeFaviconAndTitle(FaviconModel.DEFAULT.id, FaviconModel.DEFAULT.title);
        }
      },
    });

    if (!isCustomer && store.state.booster?.myOrdersWithActiveChat[message.roomId]) {
      if (!store.state.booster.myOrdersWithActiveChat[message.roomId].has_unread_messages) {
        ctx.$set(store.state.booster.myOrdersWithActiveChat[message.roomId], 'has_unread_messages', true);
      }
    }

    store.commit('notifications/mutateAddNotification', {
      entity: 'user',
      notification,
    });
  });
};

export const removeNewMessageEventListeners = (ctx) => {
  ctx.$store.state.tabManager.tabManager.removeListener(Events.NEW_MESSAGE);
  ctx.$socket.removeNamespaceListeners(SOCKET_CHAT, Events.NEW_MESSAGE);
};
